<template>
  <dialog-add
    icon="upload"
    :title="$t('bulk_upload')"
    is-fullscreen
    :is-on="true"
    :on-close="onCancel"
    class="tracking-bulk-upload-dialog"
  >
    <template v-slot:content>
      <forms-tracking-bulk-upload
        :on-cancel="onCancel"
        class="elevation-1"
      />
    </template>
  </dialog-add>
</template>

<script>
export default {
  methods: {
    onCancel() {
      this.$router.push('/tracking-management');
    },
  },
};
</script>

<style>
.tracking-bulk-upload-dialog > .modal > .modal__backdrop > .modal__content {
  width: 690px;
}
</style>
